import { render } from "./AclListRulesTab.vue?vue&type=template&id=228a0190&scoped=true"
import script from "./AclListRulesTab.vue?vue&type=script&lang=js"
export * from "./AclListRulesTab.vue?vue&type=script&lang=js"

import "./AclListRulesTab.vue?vue&type=style&index=0&id=228a0190&lang=scss&scoped=true"

import exportComponent from "/root/mold/diplo/dist/rpmbuild/BUILD/cloudstack-4.21.0.0-Diplo-202603161407/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-228a0190"]])

export default __exports__